import { createContext, useContext, type ReactNode } from "react";
import type { AppApiClient } from "@/shared/api/contracts";
import { devMockApiClient } from "@/shared/api/devMockApiClient";
import { shouldUseDevMockApi } from "@/shared/api/mockScenarios";
import { realApiClient } from "@/shared/api/real/realApiClient";

const ApiClientContext = createContext<AppApiClient | null>(null);

export function ApiClientProvider({
  children,
  client = shouldUseDevMockApi() ? devMockApiClient : realApiClient,
}: {
  children: ReactNode;
  client?: AppApiClient;
}) {
  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

export function useApiClient() {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error("useApiClient must be used inside ApiClientProvider");
  }
  return client;
}
